// Import
import $ from 'jquery';
import select2 from 'select2';

// Hook up select2 to jQuery
select2($);

// Initialize select2 instances
$(document).ready(function () {
    $('.ginput_container_select .gfield_select, .ginput_container_time select').select2({
        minimumResultsForSearch: Infinity,
        placeholder: 'Select an option'
    });
    
    $('.name_prefix_select select, .name_suffix_select select, .ginput_container_date select').select2({
        minimumResultsForSearch: Infinity
    });
    
    $('.ginput_container .address_country select').select2({
        placeholder: 'Select a country',
        allowClear: true
    });
    
    $('.ginput_container .address_state select').select2({
        placeholder: 'Select a state',
        allowClear: true
    });
});
